<template>
  <div class="page-wrapper">
    <!-- 顶部操作栏 -->
    <el-header class="page-header" style="height: auto;">
      <div class="table-header-box">
        <div class="section-title">自我测试</div>
        <div style="display:flex; align-items:center; gap:12px;">
          <el-button type="primary" @click="$router.push('/creatSubject')"
            >开始自测</el-button
          >
          <el-input
            v-model="searchKeyword"
            placeholder="请输入科目名称关键字"
            clearable
            prefix-icon="el-icon-search"
            style="width: 220px;"
          />
        </div>
      </div>
    </el-header>

    <!-- 下方主表格区域 -->
    <el-main class="page-main">
      <div class="table-container">
        <el-table
          v-loading="loading"
          element-loading-text="正在为您加载自测记录..."
          :data="filteredList"
          style="width: 100%"
          height="100%"
          stripe
          :border="false"
          :header-cell-style="{
            background: '#f8fafc',
            color: '#475569',
            fontWeight: 'bold'
          }"
          class="custom-table"
          :default-sort="{ prop: 'date', order: 'descending' }"
        >
          <el-table-column fixed prop="catalog" label="课程" min-width="200">
          </el-table-column>

          <el-table-column
            prop="createTime"
            label="提交日期"
            sortable
            min-width="180"
          >
          </el-table-column>

          <el-table-column label="操作" min-width="120">
            <template slot-scope="scope">
              <el-button
                type="text"
                class="action-btn"
                @click.stop="goToAnalysis(scope.row)"
                >查看解析</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-main>
  </div>
</template>

<script>
import { getStudentID } from "@/util/session";
import { Message } from "element-ui";
import { getPageList } from "@/api/student";

export default {
  name: "BistIndex",
  components: {},
  data() {
    return {
      loading: false,
      resultList: [],
      searchKeyword: ""
    };
  },
  computed: {
    filteredList() {
      if (!this.searchKeyword.trim()) return this.resultList;
      const kw = this.searchKeyword.trim().toLowerCase();
      return this.resultList.filter(
        item => item.catalog && item.catalog.toLowerCase().includes(kw)
      );
    }
  },
  mounted() {
    this.guardAndLoad();
  },
  methods: {
    async guardAndLoad() {
      this.loadSelfTestData();
    },
    loadSelfTestData() {
      this.loading = true;
      this.resultList = [];
      const studentID = getStudentID();
      let p1 = Promise.resolve();
      if (studentID != null) {
        p1 = getPageList({
          limit: 20,
          page: 1,
          studentId: studentID
        })
          .then(res => {
            res.data.forEach(item => {
              var objectiveNum = item.singXNum + item.multXNum + item.judgXNum;
              var subjectiveNum =
                item.fillXNum + item.anwsXNum + item.proofXNum;
              var objectiveCorrectNum =
                item.singXCorrect + item.multXCorrect + item.judgXCorrect;
              var subjectiveCorrectNum =
                item.fillXCorrect + item.anwsXCorrect + item.proofXCorrect;
              var dataList = {
                answer: item.answer,
                catalog: item.catalog,
                objectiveNum: objectiveNum,
                subjectiveNum: subjectiveNum,
                objectiveAccuracy:
                  ((objectiveCorrectNum * 1) / objectiveNum) * 1 * 100 > 0
                    ? (
                        ((objectiveCorrectNum * 1) / objectiveNum) *
                        1 *
                        100
                      ).toFixed(0) + "%"
                    : "无",
                subjectiveAccuracy:
                  ((subjectiveCorrectNum * 1) / subjectiveNum) * 1 * 100 > 0
                    ? (
                        ((subjectiveCorrectNum * 1) / subjectiveNum) *
                        1 *
                        100
                      ).toFixed(0) + "%"
                    : "无",
                createTime: item.updateTime
              };
              this.resultList.push(dataList);
            });
          })
          .catch(() => {
            Message.warning("获取试卷列表失败");
          });
      }
      p1.finally(() => {
        this.loading = false;
      });
    },
    openDetails(row) {
      let idList = JSON.parse(row.answer);

      let params = [];
      idList.forEach(item => {
        params.push(item.id);
      });

      sessionStorage.setItem("test_detail_idList", JSON.stringify(idList));
      this.$router.push({
        path: "/home/test-detail",
        query: {
          questionIdArr: params,
          catalog: row.catalog,
          show: 2
        }
      });
    },
    goToAnalysis(row) {
      this.$router.push({
        path: "/bistAnalysis",
        query: {
          title: row.catalog,
          analysis: 1,
          answer: row.answer
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/examination-page.scss";

/* 参考风格.md 新增自适应布局样式 */
.page-wrapper {
  background-color: #f5f7fa;
  height: calc(100vh - 48px);
  display: flex;
  flex-direction: column;
  padding: 0;
}

.page-header {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  padding: 15px 20px;
  margin-bottom: 20px;

  .table-header-box {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .section-title {
      font-size: 18px;
      font-weight: 800;
      color: #1e293b;
      position: relative;
      padding-left: 12px;

      &::before {
        content: "";
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 4px;
        height: 18px;
        background: #2563eb;
        border-radius: 2px;
      }
    }
  }
}

.page-main {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  padding: 20px;
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  flex: 1;
}

.table-container {
  flex: 1;
  overflow: hidden;
  height: 100%;
}

.custom-table {
  width: 100%;
  ::v-deep .el-table__row > td {
    border-bottom: 1px solid #ebeef5;
  }
  ::v-deep::before {
    display: none;
  }
}

.action-btn {
  font-size: 14px;
}
</style>
